export function removeIndex<T>(arr: readonly T[], index: number): T[] {
  return arr.slice(0, index).concat(arr.slice(index + 1));
}
